"use client";

import { c as _c } from "react/compiler-runtime";
import { useIsHydrated } from "@opensea/ui-kit/hooks";
import { useQuery as urqlUseQuery } from "@urql/next";
import { isEmpty } from "es-toolkit/compat";
import { omit, toMerged } from "es-toolkit/object";
import { useMemo } from "react";
import { useOperationContext } from "./client/context/OperationContextProvider";

/**
 * A wrapper around `urql`'s `useQuery` hook that throws an error if the query returns an error.
 * Can be opted out for specific cases (e.g. in Layouts where we may want to render children even if the query errors)
 */
export function useQuery(args, t0) {
  const $ = _c(16);
  const {
    throwOnError: t1
  } = t0 === undefined ? {} : t0;
  const throwOnError = t1 === undefined ? true : t1;
  const operationContext = useOperationContext();
  const isHydrated = useIsHydrated();
  let t2;
  bb0: {
    if (!(operationContext || args.context)) {
      t2 = undefined;
      break bb0;
    }
    if (typeof window !== "undefined" && typeof operationContext?.fetchOptions === "object" && operationContext.fetchOptions.headers && "cookie" in operationContext.fetchOptions.headers) {
      let t3;
      if ($[0] !== args.context || $[1] !== operationContext) {
        const withoutCookie = omit(operationContext, ["fetchOptions", "headers", "cookie"]);
        if (isEmpty(withoutCookie)) {
          t2 = args.context;
          break bb0;
        }
        let t4;
        if ($[4] !== args.context) {
          t4 = args.context ?? {};
          $[4] = args.context;
          $[5] = t4;
        } else {
          t4 = $[5];
        }
        t3 = toMerged(withoutCookie, t4);
        $[0] = args.context;
        $[1] = operationContext;
        $[2] = t3;
        $[3] = t2;
      } else {
        t3 = $[2];
        t2 = $[3];
      }
      t2 = t3;
      break bb0;
    }
    let t3;
    if ($[6] !== operationContext) {
      t3 = operationContext ?? {};
      $[6] = operationContext;
      $[7] = t3;
    } else {
      t3 = $[7];
    }
    let t4;
    if ($[8] !== args.context) {
      t4 = args.context ?? {};
      $[8] = args.context;
      $[9] = t4;
    } else {
      t4 = $[9];
    }
    let t5;
    if ($[10] !== t3 || $[11] !== t4) {
      t5 = toMerged(t3, t4);
      $[10] = t3;
      $[11] = t4;
      $[12] = t5;
    } else {
      t5 = $[12];
    }
    t2 = t5;
  }
  const mergedContext = t2;
  let t3;
  if ($[13] !== args || $[14] !== mergedContext) {
    t3 = {
      ...args,
      context: mergedContext
    };
    $[13] = args;
    $[14] = mergedContext;
    $[15] = t3;
  } else {
    t3 = $[15];
  }
  const result = urqlUseQuery(t3);
  const error = result[0].error;
  if (error && throwOnError && isHydrated) {
    if (!error.networkError) {
      console.error("Error in useQuery: ", args.query, error);
      throw error;
    }
  }
  return result;
}